import { Components, Theme } from '@mui/material/styles';

import { getDataTestId } from '@/utils/browser';

import { elevationLevel } from '../constants';

export const selectConfigs: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    size: 'small',
    variant: 'outlined',
    fullWidth: true,
    MenuProps: {
      autoFocus: false,
      transitionDuration: 0,
      slotProps: {
        paper: {
          ...getDataTestId(`select-menu`),
          elevation: elevationLevel.m,
          sx: theme => ({
            border: `1px solid ${theme.palette.grey[200]}`,
            padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
            paddingTop: 0,
            maxHeight: 200,

            '.MuiList-root': {
              minWidth: 125,
              padding: 0,
            },

            [theme.breakpoints.up('lg')]: {
              maxHeight: 280,
              maxWidth: 360,
            },
          }),
        },
      },
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      minWidth: 0,
      height: 44,
      paddingRight: theme.spacing(0.5),

      '.MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
        paddingRight: 0,
      },
      '&.multiSelectItem': {
        height: 'auto',
      },

      '.MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.grey[600]}`,
        transition: theme.transitions.create(['border-color', 'color']),
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[1000],
        borderWidth: 1,
      },
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
        borderWidth: 1,
      },
    }),
  },
};
